module.exports = __webpack_public_path__ + "static/media/2-option10-4row.b7efd6b4.png";